/**
 * /tenants/$slug/organizations/$orgId — thin route shim (CIAM Slice 10).
 */

import { applicationAccessSearchSchema } from "@/features/ciam-applications/schemas";
import { memberApprovalSearchSchema } from "@/features/member-approval/schemas";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchOrganization } from "@/features/organizations/queries";
import { organizationTabSchema } from "@/features/organizations/schemas";
import { queryKeys } from "@/lib/query-keys";
import { OrganizationPage } from "@/features/organizations/pages/organization-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/organizations/$orgId",
)({
  validateSearch: applicationAccessSearchSchema
    .extend(memberApprovalSearchSchema.shape)
    .extend({ tab: organizationTabSchema.optional() }).parse,
  beforeLoad: ({ search, params }) => {
    // Preserve request-history bookmarks while the organization page keeps
    // policy configuration and the membership desk owns all review actions.
    if (search.memberStatus || search.memberCursor) throw redirect({
      to: "/tenants/$slug/access-governance/membership",
      params: { slug: params.slug },
      search: { organization_id: params.orgId, status: search.memberStatus ?? "pending", cursor: search.memberCursor },
      replace: true,
    });
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.organizations.detail(context.tenant.id, params.orgId),
      queryFn: () => fetchOrganization(context.tenant.id, params.orgId),
    }),
  component: OrganizationPage,
});
